import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Introduction to Excel Interface and Navigation",
  "Functions and Formulas (IF, VLOOKUP, INDEX-MATCH, etc.)",
  "Pivot Tables & Charts",
  "Data Cleaning and Formatting Techniques",
  "Conditional Formatting",
  "Dashboards and Data Visualization",
  "Macros and Excel Automation (Basic VBA)",
  "Real-world Projects and Case Studies",
];
const STRUCTURE = [
  { title: "Admission",                    desc: "Eligibility check and onboarding process." },
  { title: "Training — 3 Weeks",           desc: "Focused Excel training with expert mentors." },
  { title: "Practical Assignments",        desc: "Apply skills through hands-on exercises." },
  { title: "Final Assessment",             desc: "Comprehensive test and project work." },
  { title: "Project Work & Feedback",      desc: "Build real-world Excel dashboards." },
  { title: "Certification & Career Help",  desc: "Resume building and career assistance." },
];
const AdvancedExcel = () => (
  <CourseDetailTemplate title="Advanced Excel Certification Course"
    description="Master Excel and take your data management skills to the next level! Learn formulas, data analysis, pivot tables, and visualization techniques. Boost your career with hands-on projects and industry-relevant knowledge."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Excel", "VBA", "Pivot Tables", "Data Analysis", "Dashboards"]}
    programName="Advanced Excel Certification Course"
  />
);
export default AdvancedExcel;
